(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/hero/assets/javascripts/hero.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/hero/assets/javascripts/hero.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const clx = svs.components.lbUtils.clx;
const resolveCompetitionBackground = svs.components.marketplaceCompetition.helpers.resolveCompetitionBackground;
const Image = svs.content.image_v2.Image;
const Hero = _ref => {
  let branding = _ref.branding,
    children = _ref.children,
    className = _ref.className,
    competitionId = _ref.competitionId,
    height = _ref.height,
    horizontal = _ref.horizontal,
    vertical = _ref.vertical;
  const imageOptions = resolveCompetitionBackground(competitionId);
  return React.createElement("div", {
    className: clx('competition-hero', branding && "competition-hero-branding-".concat(branding), ['left', 'center', 'right'].includes(horizontal) && "competition-hero-".concat(horizontal), ['top', 'middle', 'bottom'].includes(vertical) && "competition-hero-".concat(vertical), className),
    "data-testid": "qa-competition-hero",
    style: _objectSpread({}, !isNaN(height) && {
      height: "".concat(height, "px")
    })
  }, imageOptions && React.createElement(Image, {
    cssSelectors: "competition-hero-background-image",
    image: _objectSpread(_objectSpread({}, imageOptions), {}, {
      title: 'Competition hero image',
      alt: 'Competition hero image'
    })
  }), React.createElement("div", {
    className: "competition-hero-content",
    "data-testid": "qa-competition-hero-content"
  }, children));
};
setGlobal('svs.components.marketplaceCompetition.hero.Hero', Hero);

 })(window);